export default __webpack_public_path__ + "static/start-f91d1ac8780e190df435095b406b335d.png";